import DropdownMenu from "@/common/components/DropdownMenu";
import { EllipsisVerticalIcon } from "lucide-react";
import { useState } from "react";
import { DashboardData } from "../../types/dashboards/dashboard.type";
import UpdateDashboard from "./UpdateDashboard";
import UpdateDashboardVisibility from "./UpdateDashboardVisibility";

interface DashboardHeaderProps {
  dashboard: DashboardData;
  dashboardUpdatedAt: number;
  isCreator: boolean;
  hasPermissionToUpdateDashboard: boolean;
}

const DashboardHeader = ({
  dashboard,
  dashboardUpdatedAt,
  isCreator,
  hasPermissionToUpdateDashboard,
}: DashboardHeaderProps) => {
  const [updateModalIsOpen, setUpdateModalIsOpen] = useState(false);
  const [updateVisibilityModalIsOpen, setUpdateVisibilityModalIsOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-start">
        <div className="flex items-center gap-1">
          <p className="text-lg font-bold overflow-hidden text-nowrap max-w-72 overflow-ellipsis">
            {dashboard.display_name}
          </p>

          {isCreator && (
            <DropdownMenu
              triggerClassName="bg-transparent hover:bg-white-100 disabled:hover:bg-transparent transition-colors px-1.5 py-1.5 -m-1.5 ml-auto"
              triggerLabel=""
              TriggerIcon={<EllipsisVerticalIcon size={16} strokeWidth={1.5} />}
              menuPositionAlign="start"
              disabled={!hasPermissionToUpdateDashboard}
              tooltipMessage={!hasPermissionToUpdateDashboard ? 'Você não tem permissão' : undefined}
              options={[
                {
                  label: "Editar",
                  onClick: () => setUpdateModalIsOpen(true),
                },
                {
                  label: "Alterar visibilidade",
                  onClick: () => setUpdateVisibilityModalIsOpen(true),
                },
              ]}
            />
          )}
        </div>
      </div>

      <UpdateDashboard
        dashboard={dashboard}
        dashboardUpdatedAt={dashboardUpdatedAt}
        isOpen={updateModalIsOpen}
        setIsOpen={setUpdateModalIsOpen}
      />

      <UpdateDashboardVisibility
        dashboard={dashboard}
        isOpen={updateVisibilityModalIsOpen}
        setIsOpen={setUpdateVisibilityModalIsOpen}
      />
    </>
  );
}

export default DashboardHeader;
